export enum EPageTitle {
  PROJECT_CHARACTERISTICS = 1,
  BUILDING_CHARACTERISTICS = 2,
  COMPONENTS = 3,
  INDICATORS = 4,
  RESULTS = 5,
  HELP = 6
}
